<template>
  <div class="step-3-preview">
    <div class="preview-header">
      <span class="summary-text">Total files to import: <b>{{ uploadedFiles.length }}</b></span>
    </div>

    <div class="files-container">
      <div class="file-preview-card">
        <div class="file-header">
          <div class="file-title">
            <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.33333 1.66667L14 6.33333V16.6667C14 17.1087 13.8244 17.5326 13.5118 17.8452C13.1993 18.1577 12.7754 18.3333 12.3333 18.3333H3.66667C3.22464 18.3333 2.80072 18.1577 2.48816 17.8452C2.17559 17.5326 2 17.1087 2 16.6667V3.33333C2 2.89131 2.17559 2.46738 2.48816 2.15482C2.80072 1.84226 3.22464 1.66667 3.66667 1.66667H9.33333ZM8.5 2.5H3.66667C3.44565 2.5 3.23369 2.5878 3.07741 2.74408C2.92113 2.90036 2.83333 3.11232 2.83333 3.33333V16.6667C2.83333 16.8877 2.92113 17.0996 3.07741 17.2559C3.23369 17.4122 3.44565 17.5 3.66667 17.5H12.3333C12.5543 17.5 12.7663 17.4122 12.9226 17.2559C13.0789 17.0996 13.1667 16.8877 13.1667 16.6667V7.5H8.5V2.5ZM9.33333 3.67833V6.66667H12.3217L9.33333 3.67833ZM5.33333 9.16667H10.6667V10H5.33333V9.16667ZM5.33333 11.6667H10.6667V12.5H5.33333V11.6667ZM5.33333 14.1667H8.66667V15H5.33333V14.1667Z" fill="#10B981"/>
            </svg>
            <span class="file-name">Mapping Configuration</span>
          </div>
        </div>

        <div class="mappings-container">
          <div class="id-mapping-box" v-if="hasIdMappings">
            <div class="id-mapping-item" v-if="globalMapping.identificationCells && globalMapping.identificationCells.parent_item_code">
              <div class="id-label">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.9 16.21 7 11.85 7 9Z" fill="#d97706"/>
                  <circle cx="12" cy="9" r="2.5" fill="#d97706"/>
                </svg>
                ERP MATERIAL ID
              </div>
              <div class="arrow-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="id-value">{{ globalMapping.identificationCells.parent_item_code.address }}</div>
            </div>

            <div class="id-mapping-item" v-if="globalMapping.identificationCells && globalMapping.identificationCells.erp_bom_id">
              <div class="id-label">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22C12 22 19 14.25 19 9C19 5.13 15.87 2 12 2ZM7 9C7 6.24 9.24 4 12 4C14.76 4 17 6.24 17 9C17 11.88 14.12 16.19 12 18.88C9.9 16.21 7 11.85 7 9Z" fill="#d97706"/>
                  <circle cx="12" cy="9" r="2.5" fill="#d97706"/>
                </svg>
                ERP BOM ID
              </div>
              <div class="arrow-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="id-value">{{ globalMapping.identificationCells.erp_bom_id.address }}</div>
            </div>
          </div>

          <div class="column-mappings-grid">
            <div class="col-mapping-item" v-for="field in bomFields" :key="field.id">
              <div class="col-label">{{ field.label }}</div>
              <div class="col-arrow">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="col-value" :class="{'unmapped': !(globalMapping.mappings && globalMapping.mappings[field.id])}">
                {{ (globalMapping.mappings && globalMapping.mappings[field.id]) ? globalMapping.mappings[field.id].name : 'Unmapped' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step3Preview',
  props: {
    uploadedFiles: {
      type: Array,
      required: true
    },
    globalMapping: {
      type: Object,
      required: true
    },
    bomFields: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    hasIdMappings () {
      return this.globalMapping.identificationCells &&
             (this.globalMapping.identificationCells.parent_item_code || this.globalMapping.identificationCells.erp_bom_id)
    }
  }
}
</script>

<style lang="scss" scoped>
.step-3-preview {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.preview-header {
  font-size: var(--text-base);
  color: #6b7280;
  margin-bottom: 12px;
  padding: 0 4px;

  b {
    color: #374151;
  }
}

.summary-text{
  font-size: var(--text-m);
}

.files-container {
  flex: 1;
  padding-right: 8px;
}

.file-preview-card {
  border: 1px solid #f3f4f6;
  border-radius: 12px;
  margin-bottom: 12px;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.file-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f3f4f6;
}

.file-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  color: #374151;
  font-size: var(--text-xs2);
}

.file-status {
  display: flex;
  align-items: center;
  gap: 12px;
}

.progress-bar-container {
  width: 100px;
  height: 6px;
  background-color: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #10b981;
  transition: width 0.3s ease;
}

.mapped-count {
  font-size: var(--text-xs1);
  color: #6b7280;
  font-weight: 600;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: var(--text-xs2);
  font-weight: 600;

  &.ready {
    background-color: #ecfdf5;
    color: #10b981;
  }

  &.pending {
    background-color: #fffbeb;
    color: #d97706;
  }
}

.mappings-container {
  padding: 12px 16px;
}

.id-mapping-box {
  background-color: #fffbeb;
  border: 1px solid #fef3c7;
  border-radius: 8px;
  padding: 10px 16px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
}

.id-mapping-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.id-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--text-xs1);
  font-weight: 600;
  color: #b45309;
}

.arrow-icon {
  color: #d1d5db;
  display: flex;
  align-items: center;
}

.id-value {
  font-size: var(--text-xs1);
  font-weight: 600;
  color: #4338ca;
  background-color: #eef2ff;
  padding: 4px 12px;
  border-radius: 6px;
}

.column-mappings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
}

.col-mapping-item {
  display: flex;
  align-items: center;
  background-color: #f9fafb;
  border-radius: 6px;
  padding: 10px 14px;
}

.col-label {
  width: 120px;
  font-size: var(--text-xs2);
  color: #6b7280;
  font-weight: 500;
}

.col-arrow {
  color: #e5e7eb;
  display: flex;
  align-items: center;
  margin: 0 12px;
}

.col-value {
  flex: 1;
  font-size: var(--text-xs2);
  color: #4338ca;
  font-weight: 600;

  &.unmapped {
    color: #9ca3af;
    font-style: italic;
    font-weight: 500;
  }
}
</style>
